<div class="text-center p-4">
  <form [formGroup]="form" class="text-gray-1100">
    <div class="mt-2">
      <h4 class="title">{{ data.isEdit ? 'Edit' : 'Add' }} View</h4>
      <p class="font-normal mb-2 description">
        active filters and sortings will be saved as a view for quick accessibility
      </p>
      <mat-form-field [style.fontSize]="'12px'" appearance="outline" class="w-full description-input mb-1">
        <div matPrefix>
          <y42-icon
            class="icon-quick-filter"
            [ngStyle]="{ 'background-color': form.controls.background_color.value }"
            [iconStyle]="{
              color:
                form.controls.background_color.value === '#f4f4fb' || form.controls.background_color.value === '#fcfcfc'
                  ? '#a6a6a6'
                  : '#ffffff'
            }"
            [icon]="state.icon"
          >
          </y42-icon>
        </div>
        <mat-label>View Description</mat-label>
        <input autocomplete="off" matInput formControlName="name" #title maxlength="30" required cdkFocusInitial />
        <mat-hint align="start">Max {{ title.value.length || 0 }}/30 Characters</mat-hint>
        <div matSuffix style="top: -2px" class="relative" *ngIf="data.isEdit === true">
          <mat-button-toggle-group
            [(ngModel)]="isPrivate"
            [ngModelOptions]="{ standalone: true }"
            class="toggle-group-deep-style"
          >
            <mat-button-toggle
              [value]="false"
              [matTooltip]="'Public View - Can be seen by everyone within the organization'"
            >
              <fa-icon [icon]="['fal', 'user-friends']"> </fa-icon>
            </mat-button-toggle>
            <mat-button-toggle [value]="true" [matTooltip]="'Private View - Can only be seen by you'">
              <fa-icon [icon]="['fal', 'lock-alt']"> </fa-icon>
            </mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </mat-form-field>
    </div>
    <div class="mt-2">
      <p class="font-weight-bold text-left mb-2">Active Settings:</p>
      <div class="bg-gray-100 filter-displayer">
        <table class="w-full text-left">
          <tr>
            <td style="width: 30px" matTooltip="Filter">
              <fa-icon class="text-gray-700" [icon]="['fal', 'filter']"> </fa-icon>
            </td>
            <td>
              <span class="capitalize text-left">{{ state.filters }}</span>
            </td>
          </tr>
          <tr *ngIf="groupDisplayText">
            <td style="width: 30px" matTooltip="Group">
              <fa-icon class="text-gray-700" [icon]="['fal', 'layer-group']"></fa-icon>
            </td>
            <td>
              <span class="capitalize">{{ groupDisplayText }}</span>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="mt-2">
      <p class="font-weight-bold text-left mb-2">Choose Color:</p>
      <div class="icon-settings-box">
        <button
          class="value-selector color-selector"
          *ngFor="let color of backgroundColors; trackBy: trackByValue"
          [style.backgroundColor]="color"
          [style.color]="color === '#f4f4fb' ? '#a6a6a6' : '#ffffff'"
          [ngClass]="{ active: form.controls.background_color.value === color }"
          mat-icon-button
          (click)="patchFormColor(color)"
          [intercomTarget]="'01-quick-filter-form-19569' + color"
        >
          <fa-icon
            class="check-icon fs-08"
            [icon]="['fal', 'check']"
            *ngIf="form.controls.background_color.value === color"
          ></fa-icon>
        </button>
      </div>
    </div>
    <div class="my-3">
      <p class="font-weight-bold text-left mb-2">Choose Icon:</p>
      <div class="icon-settings-box">
        <button
          class="value-selector icon-selector"
          *ngFor="let icon of icons; let i = index; trackBy: trackByValue"
          [style.borderColor]="form.controls.icon.value === icon ? '#52B5FF' : 'transparent'"
          mat-icon-button
          (click)="patchFormIcon(icon)"
          [intercomTarget]="'01-quick-filter-form-74447' + i"
        >
          <fa-icon class="fs-07" [icon]="['fal', icon]"></fa-icon>
        </button>
      </div>
    </div>
    <div class="text-center mt-2">
      <button
        mat-raised-button
        color="primary"
        [disabled]="form.invalid"
        (click)="submit()"
        [intercomTarget]="'01-quick-filter-form-60289'"
      >
        Save
      </button>
    </div>
  </form>
</div>
